"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = require("react");

var useIsomorphicLayoutEffect_1 = tslib_1.__importDefault(require("./useIsomorphicLayoutEffect"));

function useObservable(observable$, initialValue) {
  var _a = react_1.useState(initialValue),
      value = _a[0],
      update = _a[1];

  useIsomorphicLayoutEffect_1["default"](function () {
    var s = observable$.subscribe(update);
    return function () {
      return s.unsubscribe();
    };
  }, [observable$]);
  return value;
}

exports["default"] = useObservable;